




import * as c from "@/utils/chart";
import { KEY_METRICS } from "@/config/series";
import { KeyStats } from "@/types/debug-mode";
import { Component, Vue, Prop } from "vue-property-decorator";
import { State } from "vuex-class";

@Component
export default class KeyStatsChart extends Vue {
  @State(state => state.debugMode.keyStatsSeries) keyStatsSeries!: KeyStats;

  @Prop({ required: true })
  chartID!: string;

  @Prop({ required: true })
  keyName!: string;

  get keySeries() {
    return this.keyStatsSeries[this.keyName];
  }

  // Make sure data has been returned by the API before trying to render chart
  get dataReady() {
    return this.keySeries && this.keySeries.length > 0;
  }

  // Get only the required columns from all values
  values() {
    if (!this.dataReady) {
      return;
    }

    const metrics = c.getMetrics(this.chartID);
    const matchedIndexes = metrics.map(metric => {
      return c.getValuesIdxByMetric(KEY_METRICS, metric);
    });

    return this.keySeries.map(point => {
      const updatedPoint = [];
      updatedPoint.push(point[0]); // add time
      // [1] `name` always skipped
      // loop through metrics and push matched IDs only
      for (const i of matchedIndexes) {
        updatedPoint.push(point[i]);
      }
      return updatedPoint;
    });
  }
}
